exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.message-container[data-v-94d46d5e]{\r\n  display: inline-block;\r\n  vertical-align: top;\r\n  cursor: pointer;\n}\n.mb-message-badge[data-v-94d46d5e]{\r\n  height: 60px;\r\n  line-height: 60px;\r\n  vertical-align: top;\n}\n.mb-message-badge .iconfont[data-v-94d46d5e]{\r\n  line-height: 60px;\r\n  font-size: 20px;\r\n  color: #7891BE;\n}\r\n", ""]);

// exports
